/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://gdpim5fzhvaxlghdz25nmjlw4u.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-goj7shet3ngoriddzzaj2pk2s4",
    "aws_cognito_identity_pool_id": "eu-central-1:002486663742:userpool/eu-central-1_P8R9cIJXS",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_P8R9cIJXS",
    "aws_user_pools_web_client_id": "2eak91g7317fktdvl5ia2bc3c",
    "oauth": {}
};


export default awsmobile;
